import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function DashboardTabs({ tabs }) {
  const [active, setActive] = useState(tabs[0].label);

  const activeTab = tabs.find((tab) => tab.label === active);

  return (
    <div className="w-full">
      {/* TAB HEADERS */}
      <div className="flex space-x-2 mb-4 border-b pb-2 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={() => setActive(tab.label)}
            className={`text-sm px-4 py-2 rounded-t ${
              active === tab.label
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* TAB CONTENT WITH ANIMATION */}
      <div className="bg-black rounded shadow p-4 min-h-[200px]">
        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -30 }}
            transition={{ duration: 0.3 }}
          >
            {activeTab?.content}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
